import React from 'react'

function TenderTextDamperS() {
  return (
    <embed src="\pdfs\EA2.1.3_s-klappe_08.2013-kr.pdf" width="100%" height="2100px" />
  )
}

export default TenderTextDamperS